import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Dropdown from "../../CoreComponents/Dropdown";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageBranchOffers,
  ManageOffers,
  ManageProducts,
  showMessage,
  ManageRestaurant,
} from "../../Functionalities/Functions";
import {
  franchise,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  token,
} from "../../Functionalities/Config";
import axios from "axios";
import { getRestaurantsUrl } from "../../Constants/apiUrls";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";

function Body(props) {
  const [disable, setdisable] = useState(false);
  let data1 = props;
  let id = data1.id;
  let type = data1.type;
  const [edit, setEdit] = useState(true);
  const [editRectangleImage, setEditRectangleImage] = useState(true);
  const [editImage, setEditImage] = useState("");
  const [radio, setRadio] = useState({
    item: true,
    adv: false,
    category: false,
    restaurant: false,
  });
  const [read, setRead] = useState(false);
  const [data, setData] = useState({
    id: "",
    item_id: "",
    disc_perc: 0,
    flat_disc: 0,
    heading: "",
    heading_ptn: "",
    heading_priority: "1000",
    expiry_date: "",
    image: "",
    prev_image: "",
    second_image: "",
    prev_second_image: "",
    type: "item",
    branch_id: "",
    branch_name: "",
    is_banner: false,
    banner_image: "",
    prev_banner_image: "",
    latitude: 0.0,
    longitude: 0.0,
  });
  const [loading, setloading] = useState(true);
  const [product, setProduct] = useState("");
  const [allProduct, setAllProduct] = useState([]);
  const [branches, setbranches] = useState([]);
  const [branch, setbranch] = useState("");
  const [selectedRestaurant, setSelectedRestaurant] = useState({});
  const [squareImagecompression, setSquareImageCompression] = useState(true);
  const [rectangleImagecompression, setRectangleImageCompression] =
    useState(true);
  const [bannerCompression, setBanneCompression] = useState(true);

  useEffect(() => {
    if (id) {
      if (type == "item") {
        setRead(true);
        setRadio({ ...radio, item: true, restaurant: false });
        fetchProductOfferData();
      }
      if (type == "branch") {
        setRead(true);
        setRadio({ ...radio, restaurant: true, item: false });
        fetchBranchOfferData();
      }
    } else {
      setloading(false);
      setRead(false);
      fetchProduct();
      getRestaurants();
    }
  }, []);

  useEffect(() => {
    (is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
      fetchBranchProduct();
  }, [branch]);

  const fetchBranchProduct = () => {
    let result = ManageProducts(
      "",
      "",
      "get",
      `for_dropdown=true&page_wise=0&branch_id=${branch}&order_by_name=true&blocked_out_drop_down=true`,
    );
    result.then((result) => {
      setAllProduct(result.data);
    });
  };

  const fetchProduct = () => {
    let result = ManageProducts(
      "",
      "",
      "get",
      `for_dropdown=true&my_branch=true&page_wise=0&order_by_name=true&blocked_out_drop_down=true`,
    );
    result.then((result) => {
      setAllProduct(result.data);
    });
  };

  const fetchProductOfferData = () => {
    let result = ManageOffers("", "", "get", `offer_type=item&offer_id=${id}`);
    result.then((result) => {
      if (result.data.results.length > 0) {
        setData({
          ...data,
          branch_id: result.data.results[0].branch,
          id: result.data.results[0].id,
          item_id: result.data.results[0].item.id,
          item_name: result.data.results[0].item.name,
          disc_perc: result.data.results[0].disc_perc,
          heading: result.data.results[0].heading,
          heading_ptn: "",
          heading_priority: result.data.results[0].heading_priority,
          expiry_date:
            result.data.results[0].expiry_date &&
            result.data.results[0].expiry_date.slice(0, 10),
          prev_image: result.data.results[0].image.image,

          prev_second_image: result.data.results[0].second_image?.image,
          type: "item",
          is_banner: result.data.results[0].is_hero_offer,
          prev_banner_image: result.data.results[0].image.image,
        });
        setloading(false);
        setProduct(result.data.results[0].item.id);
        setEditImage(result.data.results[0].image.image);
      }
    });
  };

  const fetchBranchOfferData = () => {
    let result = ManageBranchOffers(
      "",
      "",
      "get",
      `offer_type=branch&offer_id=${id}`,
    );

    result.then((result) => {
      if (result.data.results.length > 0) {
        setData({
          ...data,
          branch_id: result.data.results[0].branch.id,
          branch_name: result.data.results[0].branch.name,
          id: result.data.results[0].id,
          disc_perc: result.data.results[0].disc_perc,
          heading: result.data.results[0].heading,
          heading_ptn: result.data.results[0].heading_ptn,
          heading_priority: result.data.results[0].heading_priority,
          expiry_date:
            result.data.results[0].expiry_date &&
            result.data.results[0].expiry_date.slice(0, 10),
          prev_image: result.data.results[0].image.image,
          prev_second_image: result.data.results[0].second_image?.image,
          type: "branch",
          is_banner: result.data.results[0].is_hero_offer,
          prev_banner_image: result.data.results[0].image.image,
        });
        setloading(false);
        setbranch(result.data.results[0].branch.id);
        setEditImage(result.data.results[0].image.image);
      }
      setloading(false);
    });
  };

  const getRestaurants = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0,
    );

    let params =
      "report_drop_down=true&page_wise=false&blocked_out_drop_down=true&order_by_name=true";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => setbranches(result.data))
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0,
        );
      });
  };

  // const getRestaurants = () => {
  //   showMessage(
  //     "Loading Restaurant",
  //     "info",
  //     "Loading",
  //     "bottom",
  //     "bottom-left",
  //     0
  //   );

  //   const config = {
  //     method: "get",
  //     url: `${getRestaurantsUrl}franchise_id=${JSON.stringify(franchise.id)}`,
  //     headers: { Authorization: token },
  //   };

  //   axios(config)
  //     .then((result) => setbranches(result.data))
  //     .catch((err) => {
  //       showMessage(
  //         JSON.stringify(err),
  //         "danger",
  //         "Loading error",
  //         "top",
  //         "top-center",
  //         0
  //       );
  //     });
  // };

  const saveBanner = (e) => {
    if (data.heading === "") {
      setdisable(false);
      showMessage(
        "Heading is required",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );
      return;
    }

    if (!data.expiry_date) {
      setdisable(false);
      showMessage(
        "Expiry date is required",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );
      return;
    }

    if (data.is_banner === false) {
      if (data.prev_image === "" && data.image === "") {
        setdisable(false);
        showMessage(
          "image is required",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );
        return;
      }
    }

    if (data.is_banner === true) {
      if (data.banner_image === "" && data.prev_banner_image === "") {
        setdisable(false);
        showMessage(
          "Banner image is required",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );
        return;
      }
    }

    if (product == "") {
      var sendData = {
        ...data,
        branch_id: branch,
        latitude: selectedRestaurant?.latitude,
        longitude: selectedRestaurant?.longitude,
      };
    } else {
      var sendData = {
        ...data,
        item_id: product,
        latitude: selectedRestaurant?.latitude,
        longitude: selectedRestaurant?.longitude,
      };
    }

    if (radio.item === true) {
      if (sendData.item_id === "") {
        setdisable(false);
        showMessage(
          "Product is required",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );
        return;
      }
    } else if (radio.restaurant === true) {
      if (
        sendData.branch_id === "" &&
        (is_franchise_admin || is_franchise_manager || is_franchise_staff)
      ) {
        setdisable(false);
        showMessage(
          "Restaurant is required",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );
        return;
      }
    }

    let result = ManageOffers(e, sendData, "add", "");
    result.then((res) => {
      setdisable(false);
      if (res) {
        if (res.data.Status === true) {
          showMessage(
            "Banner added successfully",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          if (props.id) {
            window.location.replace("/banners");
          }
          setData({
            ...data,
            type: "item",
            id: "",
            item_id: "",
            disc_perc: 0,
            flat_disc: 0,
            heading: "",
            heading_priority: "1000",
            heading_ptn: "",
            expiry_date: "",
            branch_id: "",
            branch_name: "",
            is_banner: false,
            second_image: "",
            banner_image: "",
            image: "",
          });
        } else {
          showMessage(
            res.data.Error,
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      }
    });
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        {!loading ? (
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div style={{ backgroundColor: "white" }}>
                <div className="card-header">
                  <h4 className="card-title">
                    {read ? "Edit " : "Add "}Banner{" "}
                  </h4>
                </div>
                <div className="card-body" style={{ paddingTop: 0 }}>
                  <div className="basic-form ">
                    <form>
                      <div className="form-group mb-0">
                        {read ? (
                          <>
                            <div class="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Is Banner ? :{" "}
                              </label>
                              <div class="col-sm-9" style={{ marginTop: -15 }}>
                                <div className="col-sm-6" style={{}}>
                                  <div>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={data.is_banner}
                                      disabled
                                      onChange={(e) => {
                                        setData({
                                          ...data,
                                          is_banner: e.target.checked,
                                          image: "",
                                          banner_image: "",
                                          second_image: "",
                                        });
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      marginTop: 20,
                                      display: "flex",
                                      textAlign: "center",
                                    }}
                                  >
                                    <label className="form-check-label">
                                      {""}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <label className="radio-inline mr-5">
                              <input
                                type="radio"
                                name="optradio"
                                checked={radio.item}
                                disabled
                                onChange={(e) => {
                                  setRadio({
                                    ...radio,
                                    item: true,
                                    adv: false,
                                    category: false,
                                    restaurant: false,
                                  });
                                  setData({
                                    ...data,
                                    type: "item",
                                    image: "",
                                    banner_image: "",
                                    second_image: "",
                                  });
                                }}
                              />
                              Product
                            </label>
                            <label className="radio-inline mr-5">
                              <input
                                type="radio"
                                name="optradio"
                                disabled
                                checked={radio.restaurant}
                                onChange={(e) => {
                                  setRadio({
                                    ...radio,
                                    restaurant: true,
                                    adv: false,
                                    item: false,
                                    category: false,
                                  });
                                  setData({
                                    ...data,
                                    type: "branch",
                                    image: "",
                                    banner_image: "",
                                    second_image: "",
                                  });
                                }}
                              />{" "}
                              Restaurant{" "}
                            </label>
                          </>
                        ) : (
                          <>
                            <div class="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Is Hero Banner ?{" "}
                                <i
                                  className="fa fa-info-circle"
                                  style={{ cursor: "pointer" }}
                                  title="this will display on top of the app if checked true"
                                />
                                :{" "}
                              </label>
                              <div class="col-sm-9" style={{ marginTop: -15 }}>
                                <div className="col-sm-6" style={{}}>
                                  <div>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={data.is_banner}
                                      onChange={(e) => {
                                        setData({
                                          ...data,
                                          is_banner: e.target.checked,
                                          image: "",
                                          banner_image: "",
                                          second_image: "",
                                        });
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      marginTop: 20,
                                      display: "flex",
                                      textAlign: "center",
                                    }}
                                  >
                                    <label className="form-check-label">
                                      {""}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <label className="radio-inline mr-5">
                              <input
                                type="radio"
                                name="optradio"
                                value={radio.item}
                                checked={radio.item}
                                onChange={(e) => {
                                  setRadio({
                                    ...radio,
                                    item: true,
                                    adv: false,
                                    category: false,
                                    restaurant: false,
                                  });
                                  setData({
                                    ...data,
                                    type: "item",
                                    id: "",
                                    item_id: "",
                                    disc_perc: 0,
                                    flat_disc: 0,
                                    heading: "",
                                    heading_priority: "1000",
                                    heading_ptn: "",
                                    expiry_date: "",
                                    branch_id: "",
                                    branch_name: "",
                                    is_banner: false,
                                    image: "",
                                    banner_image: "",
                                    second_image: "",
                                  });
                                  setProduct("");
                                  setbranch("");
                                }}
                              />{" "}
                              Product
                            </label>
                            <label className="radio-inline mr-5">
                              <input
                                type="radio"
                                name="optradio"
                                value={radio.restaurant}
                                checked={radio.restaurant}
                                onChange={(e) => {
                                  setRadio({
                                    ...radio,
                                    restaurant: true,
                                    adv: false,
                                    item: false,
                                    category: false,
                                  });
                                  setData({
                                    ...data,
                                    type: "branch",
                                    id: "",
                                    item_id: "",
                                    disc_perc: 0,
                                    flat_disc: 0,
                                    heading: "",
                                    heading_priority: "1000",
                                    heading_ptn: "",
                                    expiry_date: "",
                                    branch_id: "",
                                    branch_name: "",

                                    is_banner: false,
                                    banner_image: "",
                                    image: "",
                                    second_image: "",
                                  });
                                  setProduct("");
                                  setbranch("");
                                }}
                              />{" "}
                              Restaurant
                            </label>
                          </>
                        )}
                      </div>
                    </form>

                    <div style={{ paddingTop: "4%" }}>
                      <form>
                        {radio.item ? (
                          read ? (
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Product{" "}
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  readOnly={read}
                                  className="form-control"
                                  value={data.item_name}
                                />
                              </div>
                            </div>
                          ) : is_franchise_admin ||
                            is_franchise_manager ||
                            is_franchise_staff ? (
                            <div>
                              <Dropdown
                                keyword="restaurant"
                                data={branches}
                                value={branch}
                                onChange={(e) => {
                                  const selectedOption =
                                    e.target.options[e.target.selectedIndex];
                                  const selectedItem = JSON.parse(
                                    selectedOption?.dataset?.item,
                                  );
                                  setSelectedRestaurant(selectedItem);
                                  setbranch(e.target.value);
                                }}
                              />
                              <Dropdown
                                keyword="product"
                                data={allProduct}
                                value={product}
                                onChange={(e) => {
                                  setProduct(e.target.value);
                                }}
                              />
                            </div>
                          ) : (
                            <Dropdown
                              keyword="product"
                              data={allProduct}
                              value={product}
                              onChange={(e) => {
                                setProduct(e.target.value);
                              }}
                            />
                          )
                        ) : radio.restaurant ? (
                          read ? (
                            (is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff) && (
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Restaurant{" "}
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    readOnly={read}
                                    className="form-control"
                                    value={data.branch_name}
                                  />
                                </div>
                              </div>
                            )
                          ) : is_franchise_admin ||
                            is_franchise_manager ||
                            is_franchise_staff ? (
                            <>
                              <Dropdown
                                keyword="restaurant"
                                data={branches}
                                value={branch}
                                onChange={(e) => {
                                  const selectedOption =
                                    e.target.options[e.target.selectedIndex];
                                  const selectedItem = JSON.parse(
                                    selectedOption?.dataset?.item,
                                  );
                                  setSelectedRestaurant(selectedItem);
                                  setbranch(e.target.value);
                                }}
                              />
                            </>
                          ) : (
                            <div></div>
                          )
                        ) : (
                          <div></div>
                        )}

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Heading
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              value={data.heading}
                              onChange={(e) => {
                                setData({ ...data, heading: e.target.value });
                              }}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Expiry date
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              value={data.expiry_date}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  expiry_date: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        {editImage != "" ? (
                          <>
                            {data.is_banner === true ? (
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Banner Image
                                  <br />
                                  <b>Compress image </b>
                                  <input
                                    type="checkbox"
                                    checked={bannerCompression}
                                    onChange={(e) => {
                                      setBanneCompression(e.target.checked);
                                      setData({ ...data, banner_image: "" });
                                    }}
                                  />
                                </label>
                                <div className="col-sm-9" style={{}}>
                                  {edit && (
                                    <img
                                      src={data.prev_banner_image}
                                      className="img-fluid rounded mr-3"
                                      height="60"
                                      width="100"
                                    />
                                  )}
                                  {!edit && (
                                    <ImageUploadWithCrop
                                      value={data.banner_image || data.prev_banner_image}
                                      onChange={(file) =>
                                        setData({
                                          ...data,
                                          banner_image: file,
                                        })
                                      }
                                      aspectRatio={1.667}
                                      compress={bannerCompression}
                                      compressMaxRes={450}
                                    />
                                  )}
                                  {edit && (
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => {
                                        setEdit(false);
                                      }}
                                    >
                                      Edit image
                                    </button>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">
                                    Square Image (160x160)
                                    <br />
                                    <b>Compress image </b>
                                    <input
                                      type="checkbox"
                                      checked={squareImagecompression}
                                      onChange={(e) => {
                                        setSquareImageCompression(
                                          e.target.checked,
                                        );
                                        setData({ ...data, image: "" });
                                      }}
                                    />
                                  </label>
                                  <div className="col-sm-9" style={{}}>
                                    {edit && (
                                      <img
                                        src={data.prev_image}
                                        className="img-fluid rounded mr-3"
                                        height="60"
                                        width="100"
                                      />
                                    )}
                                    {!edit && (
                                      <ImageUploadWithCrop
                                        value={data.image || data.prev_image}
                                        onChange={(file) =>
                                          setData({
                                            ...data,
                                            image: file,
                                          })
                                        }
                                        aspectRatio={1}
                                        compress={squareImagecompression}
                                        compressMaxRes={160}
                                      />
                                    )}
                                    {edit && (
                                      <button
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                          setEdit(false);
                                        }}
                                      >
                                        Edit image
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {/* {data.is_banner === false && (
                                  <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">
                                      Rectangle Image (240x130)
                                      <br />
                                      <b>Compress image </b>
                                      <input
                                        type="checkbox"
                                        checked={rectangleImagecompression}
                                        onChange={(e) => {
                                          setRectangleImageCompression(
                                            e.target.checked
                                          );
                                          setData({
                                            ...data,
                                            second_image: "",
                                          });
                                        }}
                                      />
                                    </label>
                                    <div className="col-sm-9" style={{}}>
                                      {editRectangleImage && (
                                        <img
                                          src={data.prev_second_image}
                                          className="img-fluid rounded mr-3"
                                          height="60"
                                          width="100"
                                        />
                                      )}
                                      {!editRectangleImage && (
                                        <ImageUploadWithCrop
                                          value={data.second_image || data.prev_second_image}
                                          onChange={(file) =>
                                            setData({
                                              ...data,
                                              second_image: file,
                                            })
                                          }
                                          aspectRatio={240 / 130}
                                          compress={rectangleImagecompression}
                                          compressMaxRes={240}
                                        />
                                      )}
                                      {editRectangleImage && (
                                        <button
                                          className="btn btn-primary"
                                          onClick={(e) => {
                                            setEditRectangleImage(false);
                                          }}
                                        >
                                          Edit image
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )} */}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {data.is_banner === true ? (
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Banner Image
                                  <span className="required">*</span>
                                  <br />
                                  <b>Compress image </b>
                                  <input
                                    type="checkbox"
                                    checked={bannerCompression}
                                    onChange={(e) => {
                                      setBanneCompression(e.target.checked);
                                      setData({ ...data, banner_image: "" });
                                    }}
                                  />
                                </label>
                                <div className="col-sm-9">
                                  <ImageUploadWithCrop
                                    value={data.banner_image || data.prev_banner_image}
                                    onChange={(file) =>
                                      setData({
                                        ...data,
                                        banner_image: file,
                                      })
                                    }
                                    aspectRatio={1.667}
                                    compress={bannerCompression}
                                    compressMaxRes={381}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">
                                    Square Image (160x160)
                                    <span className="required">*</span>
                                    <br />
                                    <b>Compress image </b>
                                    <input
                                      type="checkbox"
                                      checked={squareImagecompression}
                                      onChange={(e) => {
                                        setSquareImageCompression(
                                          e.target.checked,
                                        );
                                        setData({ ...data, image: "" });
                                      }}
                                    />
                                  </label>
                                  <div className="col-sm-9">
                                    <ImageUploadWithCrop
                                      value={data.image || data.prev_image}
                                      onChange={(file) =>
                                        setData({
                                          ...data,
                                          image: file,
                                        })
                                      }
                                      aspectRatio={1}
                                      compress={squareImagecompression}
                                      compressMaxRes={160}
                                    />
                                  </div>
                                </div>

                                {/* <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">
                                    Rectangle Image (240x130)
                                    <span className="required">*</span>
                                    <br />
                                    <b>Compress image </b>
                                    <input
                                      type="checkbox"
                                      checked={rectangleImagecompression}
                                      onChange={(e) => {
                                        setRectangleImageCompression(
                                          e.target.checked,
                                        );
                                        setData({
                                          ...data,
                                          second_image: "",
                                        });
                                      }}
                                    />
                                  </label>
                                  <div className="col-sm-9">
                                    <ImageUploadWithCrop
                                      value={data.second_image}
                                      onChange={(file) =>
                                        setData({
                                          ...data,
                                          second_image: file,
                                        })
                                      }
                                      aspectRatio={240 / 130}
                                      compress={rectangleImagecompression}
                                      compressMaxRes={240}
                                    />
                                  </div>
                                </div> */}
                              </>
                            )}
                          </>
                        )}

                        <div className="form-group row text-right">
                          <div className="col-sm-12">
                            <button
                              type="submit"
                              disabled={disable}
                              onClick={(e) => {
                                e.preventDefault();
                                setdisable(true);
                                saveBanner(e);
                              }}
                              className="btn btn-primary"
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Banners() {
  const headers = "Banners";
  let { id } = useParams();
  let { type } = useParams();
  let props = {
    id: id,
    type: type,
  };
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body {...props} />
        <Footer />
      </div>
    </div>
  );
}

export default Banners;
